import _ from 'lodash'

// rates[0].total.taxes.tax[] mixes per-stay % taxes with per-night flat fees (e.g. resort fees),
// so summing individual line items double-buckets and understates the real amount. The
// authoritative combined Taxes & Fees figure is the spread between the rate's after-tax and
// before-tax totals. Returns null (rather than 0) when either field is missing or non-numeric,
// so callers don't present an absent/invalid figure as a reconciled $0.00 total.
export default function getCombinedTaxesFeesTotal(roomRateData) {
	const amountAfterTax = _.get(roomRateData, 'rates[0].total.amountAfterTax')
	const amountBeforeTax = _.get(roomRateData, 'rates[0].total.amountBeforeTax')

	if (
		_.isNil(amountAfterTax) ||
		_.isNil(amountBeforeTax) ||
		isNaN(Number(amountAfterTax)) ||
		isNaN(Number(amountBeforeTax))
	) {
		return null
	}

	return Math.max(0, Number(amountAfterTax) - Number(amountBeforeTax))
}



// WEBPACK FOOTER //
// ./src/utilities/currency/getCombinedTaxesFeesTotal.js